import React, { ReactElement } from 'react';
import cn from 'clsx';
import Card from '@components-clean/core/card';
import { ExtendedRiskActionFields } from '@pages-clean/risk-assessment/risk-log/constants';
import styles from '@pages-clean/risk-assessment/risk-log/dialogs/email-actions/email-actions-dialog.module.scss';
import { useTranslation } from '@hooks/index';
import { stringDateWithoutTimeFromUtc } from '@utils/convertor';

const LabelText = ({ children, inline }: React.PropsWithChildren & { inline?: boolean }): ReactElement => {
    return <span className={cn(' k-font-weight-medium', { 'k-pr-2': inline })}>{children}</span>;
};

const Action = ({ action }: { action: ExtendedRiskActionFields }) => {
    const { t } = useTranslation('ram', { keyPrefix: 'riskLog.dialogs.emailActions' });
    const { recordId, requestDate, description, comments, result, owner } = action;
    return (
        <Card
            data-testid={`email-actions-action-${recordId}`}
            className="k-mt-6"
            title={`${t('sectionHeadings.action')} - ${recordId}`}
            padding="none"
            key={action.id}
        >
            <div className="k-d-flex-col k-font-size-lg">
                <div className={cn(styles.infoBlock, 'k-d-flex-row k-justify-content-start k-py-3 k-px-7.5')}>
                    <span
                        style={{
                            minWidth: 276,
                        }}
                    >
                        <LabelText inline>{t('requestedDateLabel')}</LabelText>
                        {stringDateWithoutTimeFromUtc(requestDate, 'DD-MMM-YYYY') || t('n/a')}
                    </span>
                    <span>
                        <LabelText inline>{t('owner')}</LabelText>
                        {owner.name || t('n/a')}
                    </span>
                </div>
                <div className="k-py-3 k-px-7.5 k-font-size-md">
                    <div>
                        <span className="k-font-weight-medium k-font-size-lg">{t('descriptionLabel')}</span>
                        <p>{description || t('n/a')}</p>
                    </div>
                    <div>
                        <span className="k-font-weight-medium k-font-size-lg">{t('comments')}</span>
                        <p>{comments || t('n/a')}</p>
                    </div>
                    <div>
                        <span className="k-font-weight-medium k-font-size-lg">{t('result')}</span>
                        <p>{result || t('n/a')}</p>
                    </div>
                </div>
            </div>
        </Card>
    );
};
export default Action;
